<div class="user-groups-toolbar">
  @if (!disabled()) {
    <div class="user-groups-search" style="font-size: 12px;">
      <mat-form-field appearance="outline" style="margin-bottom: 0;">
        <mat-label>{{ 'Contacts.Management.Groups.Search' | translate : locale.language }}</mat-label>
        <input matInput [formControl]="searchControl">
      </mat-form-field>
    </div>
    <div class="user-groups-classification">
      <small>
        <mat-button-toggle-group name="classification" [formControl]="classification">
          <mat-button-toggle value="All">
            {{ 'Contacts.Management.Groups.All' | translate : locale.language }}
          </mat-button-toggle>
          <mat-button-toggle value="Internal">
            {{ 'Contacts.Management.Groups.Internal' | translate : locale.language }}
          </mat-button-toggle>
          <mat-button-toggle value="Public">
            {{ 'Contacts.Management.Groups.Public' | translate : locale.language }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </small>
    </div>
  }
</div>

<div class="container">
  <app-loading [hasLoaded]="!isLoading()" [hasFailed]="hasLoadError() && !isLoading()" [isCircle]="false"
    (retryClicked)="retryPreviousRequest()"></app-loading>

  @if (!hasLoadError()) {
    <div class="groups-container">
      <div class="flex-col available-groups-container" [ngStyle]="{width: showSelectedGroups() ? '50%': '100%'}">
        <p>
          <strong>{{ 'Contacts.Management.Groups.Available' | translate : locale.language }}</strong>
        </p>

        @if (!topLevelGroups()[classification.value]?.length) {
          <span>{{ 'Contacts.Management.Groups.NoAvailableGroups' | translate : locale.language }}</span>
        }
        @for (parentGroup of topLevelGroups()[classification.value]; track parentGroup.group.id) {
          <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: parentGroup }"></ng-container>
        }
      </div>

      <ng-content select="selectedGroups"></ng-content>

      @if (showSelectedGroups()) {
        <div class="flex-col available-groups-container">
          <p>
            <strong>{{ 'Contacts.Management.Groups.Selected' | translate : locale.language }}</strong>
          </p>

          <div style="overflow-x: clip;">
            <mat-chip-set class="selected-groups-chip-list">
              @if (!selectedGroupNodes()?.length) {
                <mat-chip disabled>
                  {{ 'Contacts.Management.Groups.NoGroupsSelected' | translate : locale.language }}
                </mat-chip>
              }
              @for (node of selectedGroupNodes(); track node.group.id) {
                <mat-chip [removable]="!disabled()" (removed)="onToggleGroup(node, false)">
                  {{ node.group.name }}
                  @if (!disabled()) {
                    <button matChipRemove [attr.aria-label]="'Remove ' + node.group.name" [tabIndex]="0">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #groupTemplate let-node>
  <div class="flex-row">
    <div class="flex-col">
      <div class="flex-row" style="align-items: center">
        @if (hasChildren(node.group) && !canAssignToParentGroups()) {
          <mat-icon style="color: var(--app-text-muted); margin-left: 0.2rem; margin-right: 0.2rem;">folder</mat-icon>
        }
        @if (!hasChildren(node.group) || canAssignToParentGroups()) {
          <mat-checkbox [indeterminate]="isIndeterminate(node)" [disabled]="isNodeDisabled(node)"
            [checked]="isGroupSelected(node.group) || isParentGroupSelected(node.group)" (change)="onToggleGroup(node, $event.checked)" [aria-labelledby]="node.group.id + '-label'">
          </mat-checkbox>
        }
        <button [id]="node.group.id + '-label'" [disabled]="isNodeDisabled(node)" mat-button
          color="primary" (click)="onToggleGroup(node, undefined)" style="justify-content: left;">
          {{ node.group.name }}
        </button>
        @if (hasChildren(node.group)) {
          <button mat-icon-button (click)="onExpandNode(node)" [attr.aria-label]="(node.expanded ? 'Collapse ' : 'Expand ') + node.group.name">
            <mat-icon>{{ node.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        }
        @if (node.loading) {
          <mat-progress-bar mode="indeterminate" style="width: 50px"></mat-progress-bar>
        }
        @if (node.group.isLink) {
          <mat-icon style="color: var(--app-text-muted)">link</mat-icon>
        }
      </div>
      @if (node.expanded) {
        @for (child of getChildren(node); track child.group.id) {
          <div class="flex-row" [style.margin-left]="getIndentLevel(child)">
            <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: child }"></ng-container>
          </div>
        }
      }
    </div>
  </div>
</ng-template>
